<template>
  <div class="table-wrap">
    <div
      class="content-wrap scroll"
      v-infinite-scroll="nextPage"
      infinite-scroll-disabled="isBusy"
      infinite-scroll-distance="20"
      @scroll="scrollHandler"
    >
      <div
        v-for="category in categories.value"
        :key="category.id"
        :ref="category.id"
      >
        <context-group
          ref="group"
          :category="category"
          :isPatternView="isPatternView"
          :scroll-top="scrollTop"
        />
      </div>
    </div>
    <or-progress-linear
      v-show="isLoading"
      color="primary"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import infiniteScroll from 'vue-infinite-scroll'
import contextGroup from '@/components/common/context/context_group'

export default {
  directives: { infiniteScroll },

  components: {
    contextGroup
  },

  created () {
    window.addEventListener('scroll', this.scrollHandler)
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollHandler)
  },

  data () {
    return {
      isLoading: false,
      scrollTop: 0
    }
  },

  computed: {
    ...mapState('knowledgebase', ['categories']),

    isBusy () {
      return this.isLoading || !this.categories.isTruncated
    }
  },

  methods: {
    ...mapActions('knowledgebase', ['fetchNextCategoriesPage']),

    scrollHandler (value) {
      this.scrollTop = value.target.scrollTop
    },

    async nextPage () {
      this.isLoading = true
      await this.fetchNextCategoriesPage()
      this.isLoading = false
    }
  },

  props: {
    isPatternView: Boolean
  },

  watch: {
    categories () {
      this.$nextTick(() => this.$refs.group.forEach(group => group.resetOffsetTopAndWrapHeight()))
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wrap {
  display: flex;
  position: relative;
  flex-direction: column;
  flex-grow: 1;
  flex: 1 1 auto;
  overflow: hidden;
  height: 100%;

  .content-wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-x: scroll;
    overflow: auto;
  }
}
</style>

<style lang="scss">
.table-wrap > .content-wrap > div:nth-last-child(2) {
  .context-group-wrap {
    border-bottom: solid 1px $or-grey;
  }
}
</style>
